import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import createSerieDraftData from "astrid-firestore/src/api/series/createSerieDraftData";

import Button from "../../../ui/components/Buttons/Button";
import InstantSearch from "../../../ui/components/InstantSearch/InstantSearch";
import InstantSearchBox from "../../../ui/components/InstantSearch/InstantSearchBox";
import InstantSearchHits from "../../../ui/components/InstantSearch/InstantSearchHits";
import InstantSearchPagination from "../../../ui/components/InstantSearch/InstantSearchPagination";
import InstantSearchRefresh from "../../../ui/components/InstantSearch/InstantSearchRefresh";
import PageView from "../../../ui/views/PageView/PageView";

import SerieMetaDataEdit from "../../components/SerieMetaDataEdit/SerieMetaDataEdit";

import SeriesTable from "./components/SeriesTable";

export default function SeriesView({ organization }) {
	const { t } = useTranslation();

	const [serieDraft, setSerieDraft] = useState(null);

	const configure = {
		filters: organization && `${organization.type}.id:${organization.id}`,
	};

	return (
		<InstantSearch routing indexName="series" configure={configure}>
			<InstantSearchRefresh refreshInterval={5000} />

			<PageView
				header={t("serie", "Series")}
				extra={
					<>
						<Button
							primary
							onClick={() => setSerieDraft(createSerieDraftData({ publisher: organization }))}
						>
							{t("createSerie", "Add series")}
						</Button>
					</>
				}
				sidebar={
					<>
						<InstantSearchBox />
					</>
				}
			>
				<InstantSearchHits>
					<SeriesTable />
				</InstantSearchHits>

				<InstantSearchPagination />
			</PageView>

			{serieDraft && <SerieMetaDataEdit serie={serieDraft} onClose={() => setSerieDraft(null)} />}
		</InstantSearch>
	);
}
